
import { useDispatch } from "react-redux";
import React from "react";
import styles from "./FlooringCategoryMenu.module.css";
import { visualizerActions } from "../../store";

import FlooringTypesMenu from "../FlooringTypesMenu/FlooringTypesMenu";
import FlooringColorsMenu from "../FlooringColorsMenu/FlooringColorsMenu";

const FlooringCategoryMenu = () => {
  const dispatch = useDispatch();

  const handleTypeSelect = (obj) => {
    console.log("Selected flooring type:", obj);
    dispatch(visualizerActions.setproductDropdownFilter({
      'categoryName':obj.value
    }));

    dispatch(visualizerActions.setflooringTypeFilterObj(obj));

  };

  const handleColorFamilySelect = (obj) => {
    console.log("Selected color family:", obj);
    dispatch(visualizerActions.setflooringTypeFilterObj({}));
    dispatch(visualizerActions.setproductDropdownFilter({
      'style':obj.style
    }));
  };

  return (
    <>
      <FlooringTypesMenu handleTypeSelect={handleTypeSelect} />
      <FlooringColorsMenu handleColorFamilySelect={handleColorFamilySelect} />
    </>
  );
};

export default FlooringCategoryMenu;
